var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-1"},_vm._l((_vm.aboutMessages),function(message){return _c('div',{key:message},[_c('p',{staticClass:"text-primary line-height-condensed",class:_vm.size},[_vm._v(" "+_vm._s(_vm.$t(message))+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }